import { useEffect, useState } from "react";
import { toast } from "sonner";
import { DownloadSimple } from "@phosphor-icons/react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

export default function Reports() {
  const [group, setGroup] = useState("month");
  const [data, setData] = useState({ periods: [], rows: [] });
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    api.get(`/analytics/agent-breakup?group=${group}`).then((r) => setData(r.data)).catch(() => {});
  }, [group]);

  const exportExcel = async () => {
    setExporting(true);
    try {
      const res = await api.get(`/analytics/agent-breakup/export?group=${group}`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `MHA_Agent_Report_${group}.xlsx`; a.click();
      URL.revokeObjectURL(url);
      toast.success("Report downloaded");
    } catch { toast.error("Export failed"); }
    finally { setExporting(false); }
  };

  return (
    <div className="p-6 md:p-8">
      <div className="mb-8 flex items-end justify-between flex-wrap gap-4">
        <div>
          <p className="font-mono text-xs tracking-widest text-[#0047FF]">REPORTS</p>
          <h2 className="font-heading text-4xl font-bold tracking-tighter">Agent Lead Breakup</h2>
          <p className="text-sm text-[#555] mt-1">Leads submitted per agent, {group === "month" ? "month" : "week"} wise.</p>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex border border-[#111]">
            {["week", "month"].map((g) => (
              <button
                key={g}
                onClick={() => setGroup(g)}
                data-testid={`report-group-${g}`}
                className={`px-5 py-2 text-sm font-medium capitalize transition-colors ${group === g ? "bg-[#0047FF] text-white" : "bg-white text-[#111] hover:bg-[#f0f0ee]"}`}
              >
                {g}ly
              </button>
            ))}
          </div>
          <Button onClick={exportExcel} disabled={exporting} variant="outline" className="rounded-none border-[#111] hover:bg-[#111] hover:text-white transition-colors" data-testid="report-export-button">
            <DownloadSimple weight="bold" size={16} className="mr-2" /> {exporting ? "Exporting…" : "Export Excel"}
          </Button>
        </div>
      </div>

      <div className="bg-white border border-[#111] overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#111] text-left font-mono text-[10px] uppercase tracking-wider text-[#555]">
              <th className="px-4 py-3">Agent</th>
              {data.periods.map((p) => <th key={p} className="px-4 py-3 text-right whitespace-nowrap">{p}</th>)}
              <th className="px-4 py-3 text-right">Total</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[#eee]">
            {data.rows.length === 0 && (
              <tr><td colSpan={data.periods.length + 2} className="px-4 py-10 text-center text-[#999] font-mono text-sm">No lead data yet.</td></tr>
            )}
            {data.rows.map((r, i) => (
              <tr key={i} className="hover:bg-[#fafafa] transition-colors" data-testid={`report-row-${i}`}>
                <td className="px-4 py-3 font-medium whitespace-nowrap">{r.agent}</td>
                {data.periods.map((p) => <td key={p} className="px-4 py-3 text-right font-mono-data">{r.counts[p] || 0}</td>)}
                <td className="px-4 py-3 text-right font-mono-data font-semibold text-[#0047FF]">{r.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
